import MapDetail from "./MapDetail";
export default MapDetail;
